import defaultAxiosClient from '../../plugins/axios';
import Vue from "vue";

const initialState = {
	confirmedEmails: [],
	selectedConfirmedEmail: {}
};

const confirmedEmail = {
		namespaced: true,
		state() {
			return {...initialState};
		},
		getters: {
			confirmedEmails: state => state.confirmedEmails
		},
		mutations: {
			confirm(state) {
				state.selectedConfirmedEmail = state;
			},
			setConfirmedEmails(state, confirmedEmailDtoList) {
				state.confirmedEmails = confirmedEmailDtoList;
			},
			setSelectedConfirmedEmail(state, payload) {
				state.selectedConfirmedEmail = payload;
			},
			updateSelectedConfirmedEmail(state, payload) {
				for (let i = 0; i < state.confirmedEmails.length; i++) {
					if (state.confirmedEmails[i].emailAddress === payload.emailAddress) {
						Vue.set(state.confirmedEmails, i, payload);
					}
				}
			},
			addConfirmedEmail(state, payload) {
				const newEmail = payload.emailAddress;
				const isPresent = state.confirmedEmails.some(email => email.emailAddress === newEmail);

				if (!isPresent) {
					Vue.set(state.confirmedEmails, state.confirmedEmails.length, payload);
				}
			}
		},
		actions: {
			fetchAllConfirmedEmails({commit}) {
				return defaultAxiosClient.get(`/administration/confirmedEmail`)
					.then(response =>
						commit('setConfirmedEmails', response.data._embedded?.confirmedEmailDtoList)
					);
			},
			updateConfirmedEmail({commit}, updateConfirmedEmailDto) {
				return defaultAxiosClient.put('/administration/confirmedEmail', updateConfirmedEmailDto)
					.then(response => {
						commit('updateSelectedConfirmedEmail', response.data);
					});
			},
			createConfirmedEmail({commit}, confirmedEmailString) {
				const headers = {
					"Content-Type": "text/plain"
				};
				return defaultAxiosClient.post('/administration/confirmedEmail', confirmedEmailString, {headers})
					.then(response => {
						if (response.status === 201) {
							commit('addConfirmedEmail', response.data);
						}
					});
			}
		}
	}
;

export default confirmedEmail;